<template lang="pug">
  .modal.modal--md
    button.modal__close(
      @click="$emit('close')"
    )
      img(src="@/assets/images/icons/icon-close.svg")
    h2.modal__title Принять заявку # {{ modalData.id }}
    .modal__body
      .modal__item
        .modal__item-title Выберите время
        custom-select(
          :list-data="events"
          :show-list="true"
          :read-only="false"
          :type="'value'"
          @on-change-default-value="changeSelectValue"
          :default-value="default_event"
        )
    .modal__button.modal__button--align-right
      button.button.button_paint-error.button_long(
        @click.prevent="onButtonClick"
      )
        .button__text Отправить
      .form-elem__error(
        v-if="currentErrorMessage.length > 0"
      ) {{ currentErrorMessage }}

</template>

<script>
import { mapActions } from "vuex";
import { OrderStatusEnums } from "../../../const";
import CustomSelect from "../../../components/custom-select/custom-select";

export default {
  name: "operator-approve",
  props: ["modalData"],
  components: {
    CustomSelect,
  },
  data() {
    return {
      event: null,
      events: [],
      areas: [],
      rejectionType: "1",
      invalidDoc: "",
      otherReason: "",
      default_event: {
        value: null,
        text: "Мероприятия",
        paramName: "title",
      },
      errors: {
        invalidDoc: false,
        otherReason: false,
      },
      currentErrorMessage: "",
    };
  },
  methods: {
    ...mapActions([
      "updateOrderStatus",
      "updateOrderStatusBulk",
      "getOrders",
      "getCurrentEvent",
      "getFutureEvents",
    ]),
    changeSelectValue(item) {
      this.default_event = item;
      this.event = item.id;
    },
    onButtonClick() {
      this.updateOrderStatus({
        id: this.modalData.id,
        status: OrderStatusEnums.APPROVED, //id статуса "Принята"
        event_id: this.default_event.value,
      }).then((res) => {
        if (res.status === 200) {
          if (res.data.quota_filled === true) {
            this.$emit("changeModalMode", "notification", {
              text: "Мест нет.",
              buttonText: "Продолжить",
            });
          } else {
            this.$emit("changeModalMode", "notification", {
              title: "Успешно",
              text: "Заявка принята",
              redirectToRequests: true,
            });
          }
        } else if (res.status === 400) {
          if (res.data.quota.code == 8) {
            this.$emit("changeModalMode", "notification", {
              text: "Нет подходящей квоты для текущего пользователя.",
              buttonText: "Продолжить",
            });
          }
          if (Array.isArray(res.data)) {
            if (res.data[0].code === 20) {
              this.$emit("changeModalMode", "notification", {
                text:
                  "Данная заявка не может быть переведена в указанный статус, т.к. она находится за пределами квоты и существуют заявки с наиболее высоким рейтингом.",
                buttonText: "Продолжить",
              });
            }
          }
        }
      });
    },
  },
  mounted() {
    this.getCurrentEvent().then((res) => {
      if (res.length > 0) {
        this.default_event = {
          value: res[0].id,
          text: res[0].date_time.split("T")[1].slice(0, 5),
        };
        this.event = res[0].id;
      }
    });
    this.getFutureEvents().then((res) => {
      res.forEach((i) => {
        this.events.push({
          value: i.id,
          text: i.date_time.split("T")[1].slice(0, 5),
          paramName: "title",
        });
      });
    });
  },
};
</script>
